import React, { useEffect } from "react";
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

import CareerImg from '../Images/Career.jpg';
import Vacancies from '../Images/Vacancies.jpg';
import LifeAtAD from '../Images/LifeAtAD.jpg';
import EarlyCareers from '../Images/EarlyCareers.jpg';
import Benefits from '../Images/Benefits.jpg';

const items = [
    {
        title: "Vacancies",
        imgSrc: Vacancies,
        imgAlt: "Vacancies",
        linkSrc: "vacancies"
    },
    {
        title: "Life At Architetive Designs",
        imgSrc: LifeAtAD,
        imgAlt: "Life at Architetive Designs",
        linkSrc: "life-at-architetive-designs"
    },
    {
        title: "Early Careers",
        imgSrc: EarlyCareers,
        imgAlt: "Early Careers",
        linkSrc: "early-careers"
    },
    {
        title: "Benefits",
        imgSrc: Benefits,
        imgAlt: "Benefits",
        linkSrc: "benefits"
    }
];

const Careers = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={CareerImg} alt="Careers" className="w-full h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Careers</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <p className="text-lg mb-8 tracking-wider text-gray-700 font-light">
                    Architetive Designs welcomes designers, innovators, makers, and pioneering trailblazers to join the practice.
                </p>
                <p className="text-lg mb-8 tracking-wider text-gray-700 font-light">
                    We want to work with the best talent from across the industry and develop our people to grow within our practice. With people from diverse backgrounds, we nurture innovation and flexibility to deliver extraordinary projects.
                </p>
            </div>
            <div className="max-w-[900px] mx-auto mb-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mx-4">
                    {items.map((item, index) => (
                        <Link to={`/careers/${item.linkSrc}`} key={index}>
                            <div className="bg-[#f5f5f5] rounded-lg overflow-hidden hover:shadow-md hover:scale-[1.01] transition-transform duration-200">
                                <img src={item.imgSrc} alt={item.imgAlt} className="w-full h-56 object-cover" />
                                <div className="px-6 py-8 flex justify-between items-center">
                                    <h2 className="text-2xl text-gray-500 font-semibold">{item.title}</h2>
                                    <button className="text-gray-500 p-3 bg-white rounded-full">
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Careers;